import { z } from 'zod';

export const PrefAndCityByZipcode = z.object({
  pref: z.string(),
  city: z.string(),
  city_cd: z.string(),
  city_rome: z.string(),
  code: z.string(),
  message: z.string(),
});

export type PrefAndCityByZipcode = z.TypeOf<typeof PrefAndCityByZipcode>;

export const PrefAndCityByPref = z.object({
  city: z
    .object({
      city_cd: z.string(),
      city: z.string(),
    })
    .array(),
});

export type PrefAndCityByPref = z.infer<typeof PrefAndCityByPref>;

export const ProvAndCityItem = z.object({
  province: z.string(),
  province_local: z.string(),
  address: z.string(),
  address_local: z.string(),
  parent_code: z.string(),
  area_code: z.string(),
  city_code: z.string(),
  short_name: z.string(),
});

export type ProvAndCityItem = z.infer<typeof ProvAndCityItem>;

export const ProvAndCityByZipcode = z.object({
  list: z.array(ProvAndCityItem),
  code: z.string(),
  message: z.string(),
});

export type ProvAndCityByZipcode = z.infer<typeof ProvAndCityByZipcode>;
